// Helpers
import Helpers from '.';

// Stores
import AccountNumberStore from "../mobx/stores/AccountNumberStore";

const getAccountNumberData = (id: number) => {
    return AccountNumberStore.accountNumbers[id];
}

const getAccountNumberSelectBoxValues = () => {
    return Helpers.objectToArray(AccountNumberStore.accountNumbers)
        .map((accountNumber: any) => {
            return {
                value: accountNumber.id,
                label: accountNumber.title
            }
        })
}

const exportHelpers = {
    getAccountNumberData,
    getAccountNumberSelectBoxValues,
}

export default exportHelpers;